/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Finish_Confirm_VeknInputs */



/**
* | output |
* | --- |
* | "Results will be sent to vekn.net. Later corrections won't be sent." |
*
* @param {Finish_Confirm_VeknInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const finish_confirm_vekn = /** @type {((inputs?: Finish_Confirm_VeknInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Finish_Confirm_VeknInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Les résultats seront envoyés à vekn.net. Les corrections ultérieures ne le seront pas.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Los resultados se enviarán a vekn.net. Las correcciones posteriores no se enviarán.")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Os resultados serão enviados à vekn.net. Correções posteriores não serão enviadas.")
	if (locale === "it") return /** @type {LocalizedString} */ ("I risultati saranno inviati a vekn.net. Le correzioni successive non lo saranno.")
	return /** @type {LocalizedString} */ ("Results will be sent to vekn.net. Later corrections won't be sent.")
});